var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ban-warning"},[_c('p',[_vm._v(_vm._s(_vm.$t('chat.censor', [_vm.word])))])])
}
var staticRenderFns = []

export { render, staticRenderFns }